import { Role } from '../features/users/models/role.enum';

export const MAIN_MENU = [
  {
    label: 'Dashboard',
    icon: 'bi-grid',
    path: '/dashboard',
    roles: [Role.GERENTE, Role.SUBDIRECCION, Role.DIRECCION, Role.ADMIN],
  },
  {
    label: 'Crear KPI',
    icon: 'bi-record-circle',
    path: '/kpi/create',
    roles: [Role.GERENTE, Role.SUBDIRECCION, Role.DIRECCION, Role.ADMIN],
  },
  {
    label: 'Reportes',
    icon: 'bi-clipboard-data',
    path: '/reports',
    roles: [Role.GERENTE, Role.SUBDIRECCION, Role.DIRECCION, Role.ADMIN],
  },
  {
    label: 'Departamentos',
    icon: 'bi-building',
    path: '/departments',
    roles: [Role.SUBDIRECCION, Role.DIRECCION, Role.ADMIN],
  },
  {
    label: 'Usuarios',
    icon: 'bi-people',
    path: '/users',
    roles: [Role.SUBDIRECCION, Role.DIRECCION, Role.ADMIN],
  },
];
